import clsx from "clsx";
import { ShareIcon, Copy, Twitter, Facebook } from "../../../../assets/icons";
import { useState, useRef, useEffect } from "react";
import { toast } from "sonner";

const SharePage = ({
  username,
  plateName,
}: {
  username: string;
  plateName: string;
}) => {
  const [showShare, setShowShare] = useState(false);
  const shareMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        shareMenuRef.current &&
        !shareMenuRef.current.contains(event.target as Node)
      ) {
        setShowShare(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const copyToClipboard = (url: string) => {
    navigator?.clipboard?.writeText(url);
    setTimeout(() => {
      setShowShare(false);
    }, 2000);
    toast.success("Public profile page link copied");
  };

  const handleOpenShareMenu = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    setShowShare(!showShare);
  };

  return (
    <div className="flex items-center justify-between z-20">
      <div
        className="bg-[#ededed] p-2 rounded-lg flex flex-col relative"
        ref={shareMenuRef}
      >
        <div
          className="flex cursor-pointer items-center gap-2"
          onClick={(event) => handleOpenShareMenu(event)}
        >
          <ShareIcon width="16px" height="16px" />
          <span className="text-sm font-gt-w-medium">Share page</span>
        </div>
        <div
          className={clsx(
            "absolute top-10 z-40 w-52 pl-4 py-4 gap-6 flex-col right-[-100px] md:right-0 shadow-date bg-white rounded-lg",
            showShare ? "flex" : "hidden"
          )}
        >
          <span
            className="text-sm px-4 rounded-md py-2 cursor-pointer font-gt-w-regular flex gap-2 items-center hover:bg-[#f5f5f5]"
            onClick={() =>
              copyToClipboard(`https://www.buymejollof.com/${username}`)
            }
          >
            <Copy width="18px" height="18px" /> Copy public profile
          </span>
          <a
            href={`https://twitter.com/intent/tweet?text=I'm on @buymejollof. If you like my work, enjoy my content, you can buy me a plate of ${plateName} and share your thoughts 🎉 https://www.buymejollof.com/${username}`}
            className="w-full"
            target="_blank"
            rel="noreferrer"
          >
            <span className="text-sm rounded-md font-gt-w-regular flex gap-2 items-center px-4 py-2 hover:bg-[#f5f5f5]">
              <Twitter width="16px" height="16px" fill="black" />
              Tweet
            </span>
          </a>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=https://www.buymejollof.com/${username}`}
            className="w-full flex"
            target="_blank"
            rel="noreferrer"
          >
            <span className="text-sm rounded-md font-gt-w-regular w-full flex gap-2 items-center px-4 py-2 hover:bg-[#f5f5f5]">
              <Facebook width="16px" height="16px" />
              Share on fb
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SharePage;
